export default "__VITE_ASSET__d36ea238__"